<template>
  <dialog-v2
    :show="show"
    :title="title"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-tabs
            v-model="selectedTab"
            grow>
            <v-tabs-slider color="k-orange-linear"></v-tabs-slider>
            <v-tab
              v-for="(tab, i) in tabs"
              :key="`tab-${i}`"
              ripple>
              {{ tab.title }}
            </v-tab>
            <!-- <v-tab ripple>
              Email compromiso
            </v-tab> -->
            <v-tab-item
              v-for="(tab, i) in tabs"
              :key="`tab-item-${i}`">
              <template-textarea
                v-if="tab.type !== 'sms'"
                v-model="form[tab.name]"
                v-validate="'required'"
                :data-vv-name="tab.name"
                :append-vars="['fecha_compromiso']"
                data-vv-scope="paymentPromise"/>
              <template-textarea
                v-else-if="tab.type === 'sms'"
                v-model="(form.sms[(i - (tabs.length - (data.sms || []).length))] || {}).text"
                v-validate="(form.sms[(i - (tabs.length - (data.sms || []).length))] || {}).enabled ? 'required' : ''"
                :data-vv-name="tab.name"
                data-vv-scope="paymentPromise"/>
              <small class="red--text" v-if="errors.has(`paymentPromise.${tab.name}`)">
                Debe ingresar un texto
              </small>
              <v-layout v-if="tab.name === 'text'" row wrap mt-3>
                <v-flex xs12>
                  <v-switch
                    v-model="form.send_call_center"
                    label="Derivar llamadas al call center"
                    class="k-blue-linear-text"
                    :hide-details="true"/>
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    v-if="form.send_call_center"
                    v-model="form.call_center_number"
                    label="Ingrese numero"
                    color="black"
                    hint="Si desea que la llamada se derive a un call externo, ingrese el numero aqui"
                    :persistent-hint="true"/>
                </v-flex>
              </v-layout>
              <template v-if="tab.name === 'invalid_date_text'">
                <v-layout row wrap align-center mt-3>
                  <v-flex md5>
                    <span>Limite de días para compromiso:</span>
                    <template v-if="errors.has('paymentPromise.max_days')">
                      <br>
                      <small class="red--text">
                        {{ errors.first('paymentPromise.max_days') }}
                      </small>
                    </template>
                  </v-flex>
                  <v-flex md1>
                    <v-text-field
                      v-model="form.max_days"
                      v-validate="'required|numeric|min_value:1'"
                      data-vv-name="max_days"
                      data-vv-scope="paymentPromise"
                      class="text-xs-center pt-0"
                      color="black"
                      outline
                      placeholder="N°"
                      :hide-details="true"/>
                  </v-flex>
                </v-layout>
                <v-layout row wrap mt-3>
                  <v-flex xs12>
                    <v-switch
                      v-model="form.allow_next_month_promise"
                      label="Permitir agendar compromisos para el mes siguiente"
                      class="k-blue-linear-text"
                      :hide-details="true"/>
                  </v-flex>
                </v-layout>
              </template>
              <v-layout v-if="tab.type === 'sms' && form.sms.length" row wrap align-center mt-3>
                <v-flex xs12>
                  <v-switch
                    v-model="form.sms[(i - (tabs.length - data.sms.length))].enabled"
                    label="Activo"
                    class="k-blue-linear-text"
                    :hide-details="true"/>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!--
            <v-tab-item>
              <email-template v-model="emailTemplateForm" :append-vars="templateVars"/>
              <v-switch
                label="Enviar email de compromiso"
                v-model="form.send_email"
                class="k-blue-linear-text mt-3"
                :hide-details="true"/>
            </v-tab-item>
            -->
          </v-tabs>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';
import TemplateTextarea from '@/components/bot_v4/Detail/TemplateTextarea';
// import EmailTemplate from '@/components/Templates/Email';
import filtersMixin from '@/mixins/workflowFilters';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    DialogV2,
    TemplateTextarea,
    // EmailTemplate,
  },
  data() {
    // const emptyEmailTemplateForm = {
    //   company_email_id: '',
    //   subject: '',
    //   text: '',
    // };
    const emptyForm = {
      text: '',
      invalid_date_text: '',
      max_days: 7,
      allow_next_month_promise: true,
      send_call_center: '',
      sms: [],
      // send_email: false,
      // email: {
      //   ...emptyEmailTemplateForm,
      // },
    };
    return {
      emptyForm,
      form: {
        ...emptyForm,
      },
      // emptyEmailTemplateForm,
      // emailTemplateForm: {
      //   ...emptyEmailTemplateForm,
      // },
      selectedTab: '0',
    };
  },
  computed: {
    tabs() {
      return [
        {
          name: 'text',
          title: 'Texto',
        },
        {
          name: 'invalid_date_text',
          title: 'Fecha invalida',
        },
        ...(this.data.sms || []).map(item => ({
          ...item,
          type: 'sms',
          name: `sms_${item.status_id}`,
          title: `SMS ${this.$store.getters.status(item.status_id).status}`,
        })),
      ];
    },
  },
  methods: {
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, 'paymentPromise');
      });
    },
    save() {
      this.$validator.validateAll('paymentPromise').then((validation) => {
        if (validation) {
          this.$emit('save', this.form);
        } else {
          const errors = this.$validator.errors.items.filter(item => item.scope === 'paymentPromise');
          if (errors.length) {
            this.selectedTab = String(this.tabs.findIndex(item => item.name === errors[0].field));
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.selectedTab = '0';
        this.form = {
          ...this.data,
        };
        // this.emailTemplateForm = {
        //   ...this.form.email,
        // };
        this.clearErrors();
      } else {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          // this.emailTemplateForm = {
          //   ...this.emptyEmailTemplateForm,
          // };
          this.clearErrors();
        }, 200);
      }
    },
    // emailTemplateForm: {
    //   deep: true,
    //   handler() {
    //     // if (this.emailTemplateForm.company_email_id !== this.form.email.company_email_id) {
    //     //   this.form.email.company_email_id = this.emailTemplateForm.company_email_id;
    //     // }
    //     // if (this.emailTemplateForm.subject !== this.form.email.subject) {
    //     //   this.form.email.subject = this.emailTemplateForm.subject;
    //     // }
    //     // if (this.emailTemplateForm.text !== this.form.email.text) {
    //     //   this.form.email.text = this.emailTemplateForm.text;
    //     // }
    //   },
    // },
  },
};
</script>

<style scoped>
.input-group--text-field.text-xs-center >>> input {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/bot_v4/Detail/PaymentPromiseDialog.vue